module.exports = __webpack_public_path__ + "img/8.0ae545e2.png";